import React from "react";
import images from "../../../../../utilities/images/images";
import useAppHooks from "../../../../../shared/hooks/useAppHooks";
import "./GoToAdvAnalytics1.scss";

const GoToAdvAnalytics1 = () => {
  const { history } = useAppHooks();
  return (
    <div
      className="goToAdvAnalytics1"
      onClick={() => history.push("/adv-analytics")}
    >
      {" "}
      <img src={images.analytics} alt="icon" />
      Advanced Analytics
    </div>
  );
};

export default GoToAdvAnalytics1;
